export interface BlogPostData {
  id: string;
  title: string;
  date: string;
  description: string;
  imageUrl: string;
  contentUrl: string;
  tags?: string[];
  author: {
    name: string;
    email: string;
    photoUrl: string;
  };
}

// Sample blog data
export const blogPosts: BlogPostData[] = [
  {
    id: 'photo-scanning-guide',
    title: 'Photo Scanning Guide',
    date: 'April 6, 2025',
    description: 'Learn the best practices for scanning your photos to ensure they\'re preserved in the highest quality possible.',
    imageUrl: '/mr-cup-fabien-barral-Fo5dTm6ID1Y-unsplash.jpg',
    contentUrl: '/blog-content/photo-scanning-guide.md',
    tags: ['Scanning', 'Preservation', 'Guide'],
    author: {
      name: 'Grace Raper',
      email: 'grace@sortmyshoebox.com',
      photoUrl: '/profile.png'
    }
  },
  // {
  //   id: 'getting-started-with-photo-organization',
  //   title: 'Getting Started with Photo Organization',
  //   date: 'April 5, 2025',
  //   description: 'Learn the best practices for organizing your digital photo collection and keeping it manageable.',
  //   imageUrl: '/jason-leung-bPT0-iqUHK8-unsplash.jpg',
  //   contentUrl: '/blog-content/getting-started.md',
  //   tags: ['Organization', 'Tips', 'Beginners'],
  //   author: {
  //     name: 'Emma Johnson',
  //     email: 'emma@sortmyshoebox.com',
  //     photoUrl: '/profile.png'
  //   }
  // },
  {
    id: 'ai-photo-tagging',
    title: 'How AI is Revolutionizing Photo Tagging',
    date: 'April 2, 2025',
    description: 'Discover how artificial intelligence is making photo organization easier than ever before.',
    imageUrl: '/laura-fuhrman-73OJLcahQHg-unsplash.jpg',
    contentUrl: '/blog-content/ai-photo-tagging.md',
    tags: ['AI', 'Technology', 'Features'],
    author: {
      name: 'Michael Chen',
      email: 'michael@sortmyshoebox.com',
      photoUrl: '/profile.png'
    }
  },
  {
    id: 'preserving-family-memories',
    title: 'Preserving Family Memories for Generations',
    date: 'March 28, 2025',
    description: 'Tips and strategies for ensuring your precious family photos are preserved for future generations.',
    imageUrl: '/joanna-kosinska-spAkZnUleVw-unsplash.jpg',
    contentUrl: '/blog-content/preserving-memories.md',
    tags: ['Family', 'Archiving', 'Tips'],
    author: {
      name: 'Sarah Williams',
      email: 'sarah@sortmyshoebox.com',
      photoUrl: '/profile.png'
    }
  }
];
